/**
 * This module handles generic time related stuff
 *
 * @author Deepak Bapat (dbapat@yext.com)
 */
goog.provide('yext.time');
goog.provide('yext.time.days');

goog.require('yext');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');

yext.time.days = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

yext.time.dayAbbreviations = {
  // TRANSLATORS: Abbreviation for Monday
  'MONDAY': yext.msgc('day', 'Mon'),
  // TRANSLATORS: Abbreviation for Tuesday
  'TUESDAY': yext.msgc('day', 'Tue'),
  // TRANSLATORS: Abbreviation for Wednesday
  'WEDNESDAY': yext.msgc('day', 'Wed'),
  // TRANSLATORS: Abbreviation for Thursday
  'THURSDAY': yext.msgc('day', 'Thu'),
  // TRANSLATORS: Abbreviation for Friday
  'FRIDAY': yext.msgc('day', 'Fri'),
  // TRANSLATORS: Abbreviation for Saturday
  'SATURDAY': yext.msgc('day', 'Sat'),
  // TRANSLATORS: Abbreviation for Sunday
  'SUNDAY': yext.msgc('day', 'Sun'),
};

/**
 * Format a Date object or an date string to American 'middle-endian'
 * date format i.e. (MM/dd/yyyy)
 *
 * @param {(Date|string)} date Date object or date string
 * @return {string} Formatted date, or empty string
 */
yext.time.formatDate = function(date) {
  if (!(date instanceof Date)) {
    date = yext.time.validateDate(date);
  }
  if (date) {
    return (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
  }
  return '';
};

/**
 * Parse a date string from the American 'middle-endian' format (MM/dd/yyyy)
 * to an actual Date object
 *
 * @param {string} date
 * @return {Date}
 */
yext.time.parseDate = function(date) {
  var dateParts = date.split('/');
  return new Date(Number(dateParts[2]), Number(dateParts[0]) - 1, Number(dateParts[1]));
};

/**
 * Format a Date object or an date string to international standard ISO 8601
 * date format i.e. (yyyy-MM-dd) in the user's local time
 *
 * @param {(Date|string)} date Date object or date string
 * @return {string} Formatted date, or empty string
 */
yext.time.formatDateIso = function(date) {
  if (!(date instanceof Date)) {
    date = yext.time.validateDate(date);
  }
  if (date) {
    var year = date.getFullYear().toString().padStart(4, '0');
    // getMonth returns 0-11
    var month = (date.getMonth() + 1).toString().padStart(2, '0');
    var dayDate = date.getDate().toString().padStart(2, '0');
    return year + '-' + month + '-' + dayDate;
  }
  return '';
};

/**
 * Format an ISO 8601 date string to localized date string disregarding time and timezone.
 *
 * @param {Date|string} date Date object or date string
 * @param {string} format Either short, medium, long, or full
 * @return {string} formatted date, or empty string
 */
yext.time.formatLocalizedDate = function(date, format) {
  if (typeof date === 'string' && date) {
    // Date ISO 8601 constructor is implemented differently across browsers.
    // We slice the ISO 8601 into the year, month, day components and use that constructor instead
    // since it's consistent across browsers. Note months in javascript are 0 indexed.
    date = new Date(date.slice(0, 4), parseInt(date.slice(5, 7))-1, date.slice(8, 10));
  }
  if (date instanceof Date && !isNaN(date.valueOf())) {
    return date.format({date: format});
  }
  return '';
};

/**
 * Checks that a date is valid. If valid, Date object is returned, else false
 *
 * @param {Date|string} date Date object or date string
 * @return {Date|boolean} Returns a Date object or false if the date is invalid
 */
yext.time.validateDate = function(date) {
  if (typeof date === 'string' && date) {
    date = new Date(date);
  }
  if (date instanceof Date && !isNaN(date.valueOf())) {
    return date;
  }
  return false;
};

// Defaults for the datepicker
yext.time.datePickerDefaults = {
  minDate: null,
  maxDate: null,
  changeMonth: true,
  changeYear: true,
};

/**
 * Create a new datepicker using some defaults. To ensure that datepicker
 * internationalization is available, wait until page load to initialize the
 * datepicker
 *
 * @param {!jQueryElement} $element Input to create and bind datepicker
 * @param {function()} onChange Callback for when datepicker selection changes
 * @param {!Object} config Any additional datepicker configuration
 * @suppress {deprecated}
 */
yext.time.newDatepicker = function($element, onChange, config) {
  var _onChange = function() {
    onChange($element.datepicker('getDate'));
  };

  config = config || {};
  config.onSelect = _onChange;
  config = $.extend({}, yext.time.datePickerDefaults, config);

  $element.datepicker(config);
  $element.inputchange(_onChange);
};

yext.time.containsMeridium = (function() {
  var meridiumRegex = /[ap]/i;
  return function(val) {
    return meridiumRegex.test(val);
  };
})();

/**
 * Returns a date that is the given number of days before the current date
 *
 * @param {number} days
 */
yext.time.dateMinusDays = function(days) {
  var today = new Date();
  today.setDate(today.getDate() - days);
  return today;
};

/**
 * Returns a date that is the given number of weeks before the current date
 *
 * @param {number} weeks
 */
yext.time.dateMinusWeeks = function(weeks) {
  var today = new Date();
  today.setDate(today.getDate() - 7*weeks);
  return today;
};

/**
 * Returns a date that is the given number of months before the current date
 *
 * @param {number} months
 */
yext.time.dateMinusMonths = function(months) {
  var today = new Date();
  today.setMonth(today.getMonth() - months);
  return today;
};
